import { SearchMatchType } from '@aibees/elephant/types';
import { SearchMatchButtonConfig } from './types';

export const SEARCH_MATCH_BUTTONS_CONFIG: SearchMatchButtonConfig[] = [
  {
    type: SearchMatchType.SMART,
    label: 'Search Smart Match',
    icon: 'gps-fixed',
  },
  {
    type: SearchMatchType.WORD,
    label: 'Search Word Match',
    icon: 'manage-search',
  },
  {
    type: SearchMatchType.STRICT,
    label: 'Search Strict Match',
    icon: 'text-fields',
  },
];
